import AsyncStorage from "@react-native-async-storage/async-storage";
import { clientConfigPath, REALTIMEBOOKING } from "../../config/Constant";
import { sendAnalytics } from "./analyticsAction";



export const getRealtimeBookingUrl = (callback) => {
    return async (dispatch, getState) => {

        const room = await AsyncStorage.getItem("room");
        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const currentGuestDetails = JSON.parse(await AsyncStorage.getItem("current_guest_details"));

        if (room && room !== "null") {
            try {
                clientConfigPath
                    .get("/configsV2/fetch" + `?type=realTimeResURL&locationId=${currentGuestDetails.location}&reservationNumber=${currentGuestDetails.reservationNumber}`, {
                        headers: {
                            Authorization: `Bearer ${sessionToken}`
                        }
                    })
                    .then((res) => {
                        console.log("realTimeResURL Response" + res.status + JSON.stringify(res));
                        if (res.data.payload.realTimeResURL && res.data.payload.realTimeResURL !== "null") {
                            callback(true, res.data.payload.realTimeResURL)

                            dispatch(sendAnalytics(REALTIMEBOOKING, "FETCH REALTIMERES - SUCCESS"))
                        } else {
                            callback(false, "")
                            dispatch(sendAnalytics(REALTIMEBOOKING, "FETCH REALTIMERES - FAILED", {errorMessage: "realTimeResURL not found in response"}));
                        }
                    })
                    .catch((errResp) => {
                            const errorDescription = errResp.response.data.header.status.msg;
                            console.log("realTimeResURL api failed with the status code:", errorDescription);

                            callback(false, errorDescription);
                            dispatch(sendAnalytics(REALTIMEBOOKING, "FETCH REALTIMERES - FAILED", {errorMessage: errorDescription}))
                        }
                    )
            } catch (e) {
                callback(false, e.message)
                console.log('error in realTimeResURL api call.', e);

                dispatch(sendAnalytics(REALTIMEBOOKING, "FETCH REALTIMERES - FAILED", {errorMessage: e?.message}))
            }
        }
    }
}